import * as React from 'react'
import styled, { css, FlattenSimpleInterpolation } from 'styled-components'

import * as S from '../../../styles'

const DefaultRadiomark = styled(S.radio.Radiomark).attrs({ size: 18, status: undefined })`
  display: inline-block;
`

const CheckedRadiomark = styled(S.radio.Radiomark).attrs({ size: 18, status: 'checked' })`
  display: none;
`

const FocusedRadiomark = styled(S.radio.Radiomark).attrs({ size: 18, status: 'focused' })`
  display: none;
`

export const styleRadioToggle = (
  input: any,
  follow: any,
  styles?: {
    focus?: FlattenSimpleInterpolation
    checked?: FlattenSimpleInterpolation
    disabled?: FlattenSimpleInterpolation
  },
): FlattenSimpleInterpolation => css`
  ${input}:focus + ${follow} {
    ${FocusedRadiomark} {
      display: inline-block;
    }

    ${DefaultRadiomark}, ${CheckedRadiomark} {
      display: none;
    }

    ${styles?.focus}
  }

  ${input}:checked + ${follow} {
    ${CheckedRadiomark} {
      display: inline-block;
    }

    ${DefaultRadiomark}, ${FocusedRadiomark} {
      display: none;
    }

    ${styles?.checked}
  }

  ${input}:disabled + ${follow} {
    ${styles?.disabled}
  }
`

export const ControlledRadioInputWrapper = styled.div`
  width: 18px;
  height: 18px;
`

type ControlledRadioInputProps = {
  className?: string
  disabled?: boolean
  children?: React.ReactNode // TODO: is it needed anymore ?
}

function ControlledRadioInputComponent({
  className,
  disabled,
  children,
}: ControlledRadioInputProps): React.ReactElement<ControlledRadioInputProps> {
  return (
    <ControlledRadioInputWrapper className={className}>
      {children}
      <DefaultRadiomark disabled={disabled} />
      <FocusedRadiomark disabled={disabled} />
      <CheckedRadiomark disabled={disabled} />
    </ControlledRadioInputWrapper>
  )
}

export const ControlledRadioInput = styled(ControlledRadioInputComponent)``

const Container = styled.div``

const RadioInputWrapper = styled.div`
  ${styleRadioToggle(S.input.HiddenFocusableInput, Container, {})}
`

export type RadioInputComponentProps = {
  className?: string
  disabled?: boolean
} & React.InputHTMLAttributes<HTMLInputElement>

/** will forward any other props to the underlying `<input>` */
function RadioInputComponent({
  className,
  ...inputProps
}: RadioInputComponentProps): React.ReactElement<RadioInputComponentProps> {
  return (
    <RadioInputWrapper className={className}>
      <S.input.HiddenFocusableInput type="checkbox" {...inputProps} />
      <Container>
        <ControlledRadioInput disabled={inputProps.disabled} />
      </Container>
    </RadioInputWrapper>
  )
}

export const RadioInput = styled(RadioInputComponent)<RadioInputComponentProps>``
RadioInput.displayName = 'RadioInput'
